import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';
import { getOneClickPreloadedOrder } from '../selectors/one-click-profiles.selector';

export const getOneClickProductsState = createSelector(getOneClickState, state => state.productsState);

export const getOneClickSelectedProduct = (index: number) =>
  createSelector(getOneClickProductsState, state => state.selected[index]);

export const getOneClickProducts = createSelector(getOneClickProductsState, state => state.productsAvailable);

export const productWithPreloaded = createSelector(
  getOneClickProducts,
  getOneClickPreloadedOrder,
  (products, preloadedOrder) => ({ products, preloadedOrder }),
);
